import { RcClasses } from '../../../../foundation';
export var RcDialogContentClasses = RcClasses(['dividers'], 'RcDialogContent');
export var getRcDialogContentSpacings = function (isDividers) {
    var spacings = {
        small: isDividers ? [3, 4] : [0, 4, 1],
        medium: isDividers ? [3, 6] : [0, 6, 3],
    };
    return spacings;
};
